module.exports = __webpack_public_path__ + "img/zippo9.29472e12.webp";